import module from '../module';
import * as _ from 'lodash';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';

function CategoryController(scope, rootScope, state, messageService, stateParams, orderSetupService, groupOrder, checkoutService, cartService) {

    (async function () {
        scope.page = 1;

        scope.underConstruction = function () {
            messageService.showErrorPopup('Under Construction');
        };

        if (stateParams.externalPayerId) {
            rootScope.externalPayerId = stateParams.externalPayerId;
            state.go(Constants.RoutingStates.CATALOG);
            return;
        }

        if (rootScope.externalPayerId) {

            const externalPayerId = rootScope.externalPayerId;
            rootScope.externalPayerId = undefined;

            const cart = await cartService.getCart();
            const isGroupOrder = cartService.isGroupOrder(cart);

            const hasSavedSession = groupOrder.hasSavedSession();

            await checkoutService.submitOrder(
                'PayPal',
                scope.total, {
                    externalPayerId,
                    isAuthorization: hasSavedSession
                });

            if (hasSavedSession) {
                orderSetupService.continueOrder({
                    externalPayerId
                });
            } else {
                state.go(Constants.RoutingStates.CONFIRM_ORDER);
            }
        }
    })();
}

export default CategoryController;



// WEBPACK FOOTER //
// ./src/modules/catalog/controllers/CategoryController.js